import { Market, PrivacySettingToggles } from '../types/market';
import { no as adConfig } from '../ads';

const market: Market = {
  countryCode: 'no',
  active: true,
  permanentRedirect: true,
  sitename: 'Prisjakt',
  redirectHosts: ['m.prisjakt.no', 'prisjakt.no'],
  superSearchEndpoint: 'https://search.cloud.pji.nu/rfe',
  trackerProxy: 'rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com',
  useClassicUrls: true,
  classicProxy: {
    host: 'int-classic-no.prisjakt.io',
    port: 8080,
  },
  hrefLang: ['no'],
  locale: 'no',
  localeStandard: 'nb-NO',
  sites: {
    production: 'https://www.prisjakt.no',
    classic: 'https://classic.prisjakt.no',
    analytics: 'https://classic.prisjakt.no/analytics/store',
    brands: undefined,
    forum: undefined,
    mobile: 'https://m.prisjakt.no',
  },
  api: {
    default: 'http://int-api-no.prisjakt.io:8080/v1',
  },
  campaigns: {
    base:
      'https://search-pj-campaigns-index-oyaq7ruf3du2owxiiiuhyqcgcm.eu-west-1.es.amazonaws.com',
    previousCampaignDates: {
      '2': '2019-11-29', // BF
      '6': '2019-12-02', // CM
      '3': '2019-12-25', // Boxing day
      '12': '2020-01-01', // January sale
      '16': '2020-11-11', // Singles day
    },
  },
  googleTagManager: 'GTM-KD9S55X',
  translation: 'nb_NO',
  timezone: 'Europe/Oslo',
  currencyCode: 'NOK',
  url: {
    campaigns: '/tema',
    legacy: {
      brand: '/brand.php',
      category: '/category.php',
      fight: '/fight.php',
      forum: undefined,
      info: '/info.php',
      lists: '/lists.php',
      minhembio: undefined,
      plugin: '/plugins/',
      product: '/product.php',
      raw: '/raw.php',
      store_info: '/shop.php',
      user_login: '/login/login.php',
      mobile_site: 'https://m.prisjakt.no',
    },
  },
  socialNetworks: {
    instagram: {
      link: 'https://www.instagram.com/prisjakt.no/',
    },
    facebook: {
      enableLogin: true,
      link: 'https://www.facebook.com/PrisjaktNorge',
      clientID: '127481207276574',
      clientSecret: '2c59f54b2e9cbc5b2891b1383ab7fc74',
      callbackURL: `/_internal/auth/facebook/callback`,
    },
    twitter: {
      enableLogin: false,
      link: 'https://twitter.com/PrisjaktNorge',
      consumerKey: '1VS0ZSpS02tI1aJ1CyJzQ',
      consumerSecret: '2Ge3BfsxRLbCk2qg7zwefsE1IKfslW1r5jCNec5UJ4',
      callbackURL: `/_internal/auth/twitter/callback`,
    },
    schibsted: {
      enableLogin: true,
      clientID: '5fdb0cd77fccf0145d676563',
      clientSecret: 'urvWthuElARER0t7uZm7',
      host: 'https://payment.schibsted.no',
      callbackURL: '/_internal/auth/schibsted/callback',
    },
  },
  email: {
    noreply: 'noreply@prisjakt.no',
  },
  cdn: {
    base: 'https://pricespy-75b8.kxcdn.com',
    images: 'https://pricespy-75b8.kxcdn.com/',
  },
  routes: {
    giftGuide: {
      // HACK: Must include all current running giftGuides, hardcoded
      path: '/tema/:name(julegavetips)/:list?',
    },
    themes: {
      path: '/tema',
    },
    campaign: {
      path: '/tema/:name',
    },
    shopOfTheYear: {
      path: '/arets-butikk',
    },
    shopOfTheYearCategory: {
      path: '/arets-butikk/:year/category/:id',
    },
    shopOfTheYearWinners: {
      path: '/arets-butikk/:section',
    },
    productCompare: {
      path: '/sammenlign/produkter/:productIds?',
    },
    editorialContentListing: {
      path: '/artikler',
    },
    categoryIndex: {
      path: '/kategorier',
    },
  },
  popularCampaignFilterPaths: [
    {
      title: 'Tilbud under 500 kr',
      path: '?price=0-500',
    },
    {
      title: 'Tilbud 500-1000 kr',
      path: '?price=500-1000',
    },
    {
      title: 'Beste tilbud på hodetelefoner',
      path: '?category=148',
    },
    {
      title: 'Beste tilbud på robotstøvsugere og støvsugere',
      path: '?category=515%7C520',
    },
    {
      title: 'Jobb hjemmefra',
      path: '?category=555%7C148%7C1594',
    },
    {
      title: 'Beste tilbud på hvitevarer',
      path: '?category=504',
    },
    {
      title: 'TVs',
      path: '?category=107',
    },
  ],
  campaignFeaturedList: [
    {
      campaignId: 2,
      listId: 520202,
    },
  ],
  infoPages: [9, 5, 15, 10, 12, 4, 6, 14, 7, 8],
  infoPageMap: {
    userAgreement: 4,
    priceInformation: 5,
    privacyPolicy: 6,
    cookiePolicy: 7,
    contact: 8,
    about: 9,
    registerShop: 10,
    media: 12,
    disclaimer: 14,
    aboutReviews: 15,
    adlink: 'adlink',
    themes: 'themes',
    articles: 'articles',
    shopOfTheYear: 'shopOfTheYear',
    categoryIndex: 'categoryIndex',
    supportPage: 'supportPage',
  },
  newsletter: {
    apiUrl: 'https://api.getanewsletter.com/v3/',
    apiKey:
      '8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4',
    list: 'DiriBRd',
    gansubFormId: 'ygTTkGiPETLPh10qRO',
  },
  apps: {
    ios: '369151774',
    android: 'se.prisjakt.pricespy',
  },
  priceList: {
    featuredAlternativePriceType: 'used_product',
  },
  ads: { active: true, ...adConfig },
  privacySettings: {
    responsive: {
      cookieVersion: '4',
      cookieUrl: '/info/retningslinjer-for-bruk-av-informasjonskapsler--i7',
      privacyUrl: '/info/retningslinjer-for-personvern--i6',
      privacySettingsUrl: '/privacy-settings',
    },
    desktop: {
      cookieVersion: '4',
      cookieUrl: '/info.php?t=about_cookies',
      privacyUrl: '/info.php?t=about_privacy',
      privacySettingsUrl: '/privacy.php',
    },
    mobile: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
    native: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
  },
  modules: {
    priceInfo: {
      enabled: false,
    },
    categoryInfo: {
      enabled: false,
    },
    userReviewPurchaseDate: {
      enabled: false,
    },
    readableProductInfo: {
      enabled: true,
    },
  },
  showSchibstedCoBranding: true,
  showClassicSwitch: true,
  trackingToggles: [
    { name: PrivacySettingToggles.BehaviourTrackingImprovement, default: true },
    { name: PrivacySettingToggles.BehaviorTrackingMarketing, default: false },
    { name: PrivacySettingToggles.BehaviorTrackingSurveys, default: true },
    { name: PrivacySettingToggles.PersonalizedAds, default: true },
    { name: PrivacySettingToggles.Personalization, default: true },
  ],
  shopOfTheYear: {
    isVotingOpen: false,
    year: 2020,
  },
  cdnCache: {
    enabled: true,
    mode: 'external',
  },
  experts: {
    enabled: false,
  },
  keywordLandingPagesEnabled: true,
};

export default market;
